// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/lobby/" + {"16":"branding-halloween","369":"branding-christmas"}[chunkId] + "." + {"16":"a3cf2387","369":"089c3944"}[chunkId] + ".chunk.js";
};